import { type ConfigObject } from '../../../../_configs/types';
import { type Facets, type Filter } from '../../../../_types/Car';
import { generateLink } from '../../../../utils/generateLink';
import checkUndefinedNullOrEmpty from '../../../../utils/tools/checkUndefinedNullOrEmpty';
import type { Modules } from '../../../_definition/types';

export default function getUrlFromFilter(
    allFacets: Facets,
    settings: ConfigObject,
    filter: Filter,
    module: Modules,
    canonical: boolean
): { noPushToPage: boolean; old: string; origin: string; url: string } {
    const originalUrlObj = new URL(location.href);
    const newLink = generateLink({ allFacets, filter, module, pathOnly: false, settings, type: canonical === true ? 'landingpage' : 'filter' });
    const returnUrl = new URL(newLink);

    const rawOriginalUrl = `${originalUrlObj?.pathname?.replace(/\/$/g, '') || ''}${originalUrlObj?.search || ''}`;
    const rawNewUrl = `${returnUrl?.pathname?.replace(/\/$/g, '') || ''}${returnUrl?.search || ''}`;

    const originalUrl = checkUndefinedNullOrEmpty(rawOriginalUrl) ? '/' : rawOriginalUrl;
    const newUrl = checkUndefinedNullOrEmpty(rawNewUrl) ? '/' : rawNewUrl;

    return { noPushToPage: newUrl === originalUrl, old: originalUrl, origin: returnUrl?.origin, url: newUrl };
}
